<div class="sticky-form">
	<form>

		<mat-form-field appearance="outline" class="date-search">
			<mat-date-range-input [formGroup]="dateRangeControl" [rangePicker]="picker">
				<input matStartDate formControlName="start" placeholder="Start date">
				<input matEndDate formControlName="end" placeholder="End date">
			</mat-date-range-input>
			<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
		</mat-form-field>

		<mat-form-field appearance="outline" class="date-search">
			<mat-label>Global Search</mat-label>
			<input matInput [formControl]="globalSearch" (keyup.enter)="onEnterKey()">
			@if (globalSearch.getRawValue()) {
			<button matSuffix matIconButton class="mat-clear" aria-label="Clear" (click)="clickGlobalSearchX($event)">
				<mat-icon>close</mat-icon>
			</button>
			}
		</mat-form-field>

		<mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"
			aria-label="Select page">
		</mat-paginator>

	</form>
</div>
